



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PaginationSearchButton extends Vue {
  @Prop({ required: false, default: true }) public isVisible: boolean;
  @Prop({ required: false, default: true }) public hoverScale: boolean;

  get hasDefaultSlot() {
    return !!this.$slots.default;
  }

  private emitClick() {
    this.$emit("click");
  }
}
